import { render, staticRenderFns } from "./my-profile.vue?vue&type=template&id=3afa7dd8&scoped=true"
import script from "./my-profile.vue?vue&type=script&lang=js"
export * from "./my-profile.vue?vue&type=script&lang=js"
import style0 from "./my-profile.vue?vue&type=style&index=0&id=3afa7dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afa7dd8",
  null
  
)

export default component.exports